import { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import "../../styles/home.css";
import Widget from "../../components/widget/Widget";
import Featured from "../../components/featured/Featured";
import Chart from "../../components/chart/Chart";
import Table from "../../components/table/Table";
import { setActiveStore } from "../../redux/slices/storeSlice";

const Home = () => {
  const [initialStore, setInitialStore] = useState({});

  const { stores, activeStore } = useSelector((state) => state?.listStores);

  const dispatch = useDispatch();
  useEffect(() => {
    setInitialStore(stores && stores?.data && stores?.data[0]);
    if (!activeStore) {
      dispatch(setActiveStore(initialStore?.id));
    }
  }, [dispatch, activeStore, initialStore, stores]);
  return (
    <div className=" max-w-[100vw]">
      <div className="ml-8 mt-16">
        <span>Current Store : {activeStore?.brand_name}</span>
      </div>
      <div className="flex p-[20px] flex-col lg:flex-row flex-wrap gap-[20px]">
        <Widget type="customer" />
        <Widget type="order" />
        <Widget type="earning" />
        <Widget type="balance" />
      </div>
      <div className="p-[5px 20px] flex flex-col md:flex-row">
        <Featured />
        <Chart title="Last 6 Months (Revenue)" aspect={2 / 1} />
      </div>
      <div className="listContainer w-[100vw] overflow-x-auto">
        <div className="listTitle px-[1rem]">Latest Transactions</div>
        <Table />
      </div>
    </div>
  );
};

export default Home;
